export default (function (vueInst, googleMapsInst, events) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    var _loop = function _loop() {
      var eventName = _step.value;

      if (vueInst.$gmapOptions.autobindAllEvents || vueInst.$listeners[eventName]) {
        googleMapsInst.addListener(eventName, function (ev) {
          vueInst.$emit(eventName, ev);
        });
      }
    };

    for (var _iterator = events[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      _loop();
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
});